import { CATEGORY_KEYS, CATEGORY_KEY_BY_LABEL, INCOME_CAT_KEYS, INCOME_CAT_KEY_BY_LABEL } from './constants';

/**
 * Convert a stored category value to a display label.
 * Handles both new-format keys (e.g. "food_dining") and legacy labels.
 */
export function categoryLabel(value, customCategories = []) {
  if (!value) return '';
  if (CATEGORY_KEYS[value]) return CATEGORY_KEYS[value];
  if (INCOME_CAT_KEYS[value]) return INCOME_CAT_KEYS[value];
  const custom = customCategories.find(c => c.key === value);
  if (custom) return custom.label;
  return value; // legacy label or unknown — display as-is
}

/**
 * Normalize a category value to a key if possible.
 * If the value is already a known key, returns it unchanged.
 * If it's a known label, converts to key.
 * Unknown values are returned as-is.
 */
export function normalizeCategory(value) {
  if (!value) return value;
  if (CATEGORY_KEYS[value] || INCOME_CAT_KEYS[value]) return value; // already a key
  const key = CATEGORY_KEY_BY_LABEL[value] ?? INCOME_CAT_KEY_BY_LABEL[value];
  return key ?? value;
}

/**
 * Generate a stable key from a label string (used for custom categories).
 * Lowercases, replaces non-alphanumeric runs with underscores, trims edges.
 */
export function makeKey(label) {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}
